import axios from 'axios';
import API_HOST from '../api';
import { getProductConstant } from '../utils/genericProduct';
import { EARTHQUAKE } from '../utils/genericProduct/constants';

// getProductNotifications - gets a pageinated list of product notificiations
export const getProductNotifications = (
  clientId,
  productEventId,
  locationSetId,
  criteriaFilter,
  options = { limit: -1 },
) => {
  const url = `${API_HOST}/api/client/${clientId}/location/${locationSetId}/product-event/${productEventId}/product-notification-list`;

  const config = {
    params: {
      limit: options.limit,
      page: options.page,
      offset: options.offset,
      criteriaFilter,
    },
  };

  return axios.get(url, config);
};

export const getClientProductNotifications = (
  clientId,
  productEventId,
  criteriaFilter,
  options = { limit: -1 },
) => {
  const url = `${API_HOST}/api/client/${clientId}/product-event/${productEventId}/product-notification-list`;

  const config = {
    params: {
      limit: options.limit,
      page: options.page,
      offset: options.offset,
      criteriaFilter,
    },
  };

  return axios.get(url, config);
};

export const getProductNotificationCriteriaFilter = (productId) => {
  const productName = getProductConstant(productId);

  switch (productName) {
    case EARTHQUAKE:
      return -1;
    default:
      return null;
  }
};
